import { render, staticRenderFns } from "./GlobalGroups.vue?vue&type=template&id=0abee6aa&scoped=true"
import script from "./GlobalGroups.vue?vue&type=script&lang=js"
export * from "./GlobalGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abee6aa",
  null
  
)

export default component.exports